<template>
  <v-layout wrap justify-space-between>
    <v-flex xs12>
      <v-text-field
        label="ISBN"
        v-model="logEntry['isbn']"
      >
        <template v-slot:append v-if="false">
          <v-btn fab dark small color="primary"><v-icon>search</v-icon></v-btn>
        </template>
      </v-text-field>
    </v-flex>
    <template v-for="component in subcomponents">
      <v-flex
        v-if="component.type !== 'subcomponent'"
        :key="component.id"
        xs12
        :md5="component.type !== 'custom'"
      >
        <AirField
          v-if="component.type !== 'custom'"
          :key="component.id"
          v-model="logEntry[component.id]"
          :component="component"
        />
      </v-flex>
    </template>
  </v-layout>
</template>
<script>
import { SubComponent } from '@/models/ScientificActivity'
import AirField from './AirField'

export default {
  
  components: {
    AirField
  },
  props: {
    logEntry: { type: Object, default: null }
  },
  computed: {
    subcomponents() {
      return SubComponent.query()
        .where('owner', 'book')
        .get()
    }
  }
}
</script>